<template>
  <TeacherSchedule />
</template>

<script>
import TeacherSchedule from "../../../components/TeacherSchedule.vue";
export default { name: "week-schedule", components: { TeacherSchedule } };
</script>
